export default function (el, options) {
  const tooltip = {
    tooltip: el.nextElementSibling,
    contentFrom: null,
    reference: null,
    offsetX: 0,
    offsetY: 0,
    align: {
      top: 'top',
      left: 'center',
    },
    visibility: false,
    screen: el.getAttribute('data-help'),
    class: 'tooltip__content',
    visibleClass: 'tooltip__content--is-visible',
    allowClickEvent: false,
  };

  let settings = {};

  if (
    tooltip.screen === 'mobile' && window.matchMedia('(max-width: 767px)').matches ||
    tooltip.screen === 'all' ||
    tooltip.screen === null
  ) {
    initTooltip();
  }

  // Add listener to enable tooltip at screen resize.
  if (tooltip.screen !== 'all') {
    window.matchMedia('(max-width: 767px)').addEventListener('change', (e) => {
      if (e.matches) {
        initTooltip();
      } else {
        destroyTooltip();
      }
    });
  }

  function initTooltip() {
    // Merge user's options.
    settings = Object.assign(tooltip, options);

    el.classList.add('tooltip__trigger');
    settings.tooltip.classList.add(settings.class);

    if (!tooltip.allowClickEvent) {
      el.addEventListener('click', triggerClick);
    }
    el.addEventListener('mouseenter', triggerEnter);
    el.addEventListener('mouseleave', triggerLeave);
  }

  function destroyTooltip() {
    // Remove classes.
    el.classList.remove('tooltip__trigger');
    settings.tooltip.classList.remove(settings.class);
    settings.tooltip.classList.remove(settings.visibleClass);
    settings.tooltip.removeAttribute('style');

    // Remove events
    el.removeEventListener('click', triggerClick);
    el.removeEventListener('mouseenter', triggerEnter);
    el.removeEventListener('mouseleave', triggerLeave);
  }

  function triggerClick(e) {
    e.preventDefault();
    e.stopPropagation();

    // Mouseenter event is fired before the click event. So I invert the condition.
    if (!tooltip.visibility) {
      settings.tooltip.classList.add(settings.visibleClass);
      settings.visibility = true;
    } else {
      settings.tooltip.classList.remove(settings.visibleClass);
      settings.visibility = false;
    }
  }

  function triggerEnter() {
    settings.tooltip.classList.add(settings.visibleClass);

    // Position the tooltip from the common parent.
    if (settings.reference) {
      const offset = getPosition();
      settings.tooltip.style.left = `${offset.x}px`;
      settings.tooltip.style.top = `${offset.y}px`;
      settings.tooltip.innerHTML = settings.contentFrom;
    }
  }

  function triggerLeave(e) {
    settings.tooltip.classList.remove(settings.visibleClass);
    settings.visibility = false;
  }

  function getPosition() {
    const posX = el.getBoundingClientRect().left - settings.reference.getBoundingClientRect().left;
    const posY = el.getBoundingClientRect().top - settings.reference.getBoundingClientRect().top;

    let x = posX;
    let y = posY;

    if (tooltip.align.left === 'center') {
      const half = 2;
      x += el.getBoundingClientRect().width / half - settings.tooltip.getBoundingClientRect().width / half + settings.offsetX;
    }

    if (tooltip.align.top === 'top') {
      y -= settings.tooltip.getBoundingClientRect().height + settings.offsetY;
    }

    return {
      x,
      y,
    };
  }
}
